import { ChatAppSettingKeyEnum } from '@ztechapps/common.contract'

export const AppSettingKey = {
  CHAT_AUTO_CLOSE_AFTER_DAYS: 'CHAT_AUTO_CLOSE_AFTER_DAYS',
  // Retired: the spam sender list now lives in the `spamsenders` collection (`SpamSender`). Only the
  // migrations that moved the tag-array setting into it, and the older ones that seeded it, read this key.
  CHAT_SPAM_SENDER_LIST: ChatAppSettingKeyEnum.CHAT_SPAM_SENDER_LIST,
}
